module.exports = __webpack_public_path__ + "img/LogoSmall.bee974ac.svg";